var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11770_2086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6163 20H19.1065C20.2563 20 21.1709 19.4761 21.9921 18.7436C24.0782 16.8826 19.1743 15 17.5002 15M15.5002 5.06877C15.7273 5.02373 15.9631 5 16.205 5C18.0249 5 19.5002 6.34315 19.5002 8C19.5002 9.65685 18.0249 11 16.205 11C15.9631 11 15.7273 10.9763 15.5002 10.9312M4.48152 16.1112C7.24619 14.6296 10.7542 14.6296 13.5189 16.1112C14.6979 16.743 17.7891 18.0331 15.9063 19.6474C14.9866 20.436 13.9623 21 12.6745 21H5.32593C4.03811 21 3.0138 20.436 2.09409 19.6474C0.211343 18.0331 3.30254 16.743 4.48152 16.1112ZM13.0002 7.5C13.0002 9.70914 11.2093 11.5 9.00021 11.5C6.79107 11.5 5.00021 9.70914 5.00021 7.5C5.00021 5.29086 6.79107 3.5 9.00021 3.5C11.2093 3.5 13.0002 5.29086 13.0002 7.5Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11770_2086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.5ca8c3e73f480a27c40867ddbd3bf52e.svg";
export { ForwardRef as ReactComponent };